import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
    FaArrowRight, FaUserTie, FaUsers, FaBook, FaUserMd,
    FaGraduationCap, FaMicroscope, FaAward, FaCalculator,
    FaGlobe, FaBullhorn, FaBriefcase, FaUserGraduate,
    FaLaptopCode, FaSearch, FaHistory, FaDraftingCompass,
    FaRunning, FaBrain, FaBalanceScale, FaCogs, FaUsersCog,
    FaFileAlt, FaChartLine, FaUniversity, FaStethoscope, FaFlask
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "./Departments.module.css";
import { testUrl } from "../home/BaseData";

const Department = () => {
    const { t, i18n } = useTranslation();
    const [rectors, setRectors] = useState([]);

    useEffect(() => {
        axios
            .get(testUrl + "/api/rectors/")
            .then((response) => {
                let data = response.data;
                // Filter out rector records with no position set (prevents duplicate/empty cards)
                data = data.filter(r => r.position_uz && r.position_uz.trim() !== '');
                const normalize = (str) => str ? str.toLowerCase().replace(/['`’"“”]/g, "").trim() : "";

                const manualSequence = [
                    "Xalqaro hamkorlik bo‘yicha prorektor",
                    "Xalqaro hamkorlik va reytinglar bilan ishlash boshqarmasi",
                    "Rektor apparati – rektor yordamchisi va maslahatchilari",
                    "Inson resurslarini boshqarish boshqarmasi",
                    "Universitet axborot xizmati",
                    "Yuriskonsult, “Komplayens nazorat”",
                    "Kengashlar va majlislar kotibi",
                    "Ijro intizomi, arxiv va murojaatlar bilan ishlash bo‘limi"
                ];

                let rectorIndex = data.findIndex(r => r.position_uz && normalize(r.position_uz).includes('rektor') && !normalize(r.position_uz).includes('prorektor'));

                if (rectorIndex === -1) {
                    // Create a fallback placeholder for the Rector if deleted/missing from DB
                    const fallbackRector = {
                        id: 'rector-manual-section',
                        position_uz: "Rektor",
                        position_ru: "Ректор",
                        position_en: "Rector",
                        employee: { id: 274 },
                        departments: [],
                        is_manual_rector: true,
                        disableLink: false
                    };
                    data.unshift(fallbackRector);
                    rectorIndex = 0;
                } else if (rectorIndex > 0) {
                    const rector = data.splice(rectorIndex, 1)[0];
                    data.unshift(rector);
                    rectorIndex = 0;
                }

                // For Main Rector
                if (rectorIndex !== -1) {
                    const rector = data[rectorIndex];
                    let currentDepts = rector.departments || [];
                    let newDepts = [];

                    // 1. First, check if we need to inject the Pro-Rectors manually if they exist in the data
                    const xalqaroId = 274;
                    let xalqaroProrektor = data.find(r => r.employee && r.employee.id === xalqaroId);
                    if (xalqaroProrektor && xalqaroProrektor !== rector) {
                        xalqaroProrektor.hidden = true;
                        newDepts.push({
                            id: xalqaroId,
                            name_uz: xalqaroProrektor.position_uz,
                            name_ru: xalqaroProrektor.position_ru,
                            name_en: xalqaroProrektor.position_en,
                            type: 'employee',
                            short_id: 'emp-' + xalqaroProrektor.id
                        });
                    }

                    const xorijiyId = 185;
                    let xorijiyProrektor = data.find(r => r.employee && r.employee.id === xorijiyId);
                    if (xorijiyProrektor && xorijiyProrektor !== rector) {
                        // Note: Do NOT set hidden=true here if we want it to also show up as a separate section later
                        newDepts.push({
                            id: xorijiyId,
                            name_uz: "Xorijiy ta’lim hamkorligi markazlari rahbari-prorektor",
                            name_ru: xorijiyProrektor.position_ru,
                            name_en: xorijiyProrektor.position_en,
                            type: 'employee',
                            short_id: 'emp-' + xorijiyProrektor.id
                        });
                    }

                    // 2. Add all current departments (already sorted by order from DB)
                    currentDepts.forEach(d => {
                        const dbName = normalize(d.name_uz);
                        
                        // Apply hardcoded short_ids for specific departments to keep links working
                        if (dbName.includes("xalqaro hamkorlik") && dbName.includes("reytinglar")) d.short_id = "xalqaro-hamkorlik-bolimi";
                        if (dbName.includes("inson resurslarini")) d.short_id = "inson-resurslari";
                        if (dbName.includes("universitet axborot xizmati")) d.short_id = "axborot-xizmati";
                        if (dbName.includes("yuriskonsult") || dbName.includes("komplayens")) d.short_id = "yuriskonsult";
                        if (dbName.includes("kengashlar va majlislar")) d.short_id = "kengashlar-va-majlislar";
                        if (dbName.includes("ijro intizomi")) d.short_id = "ijro-intizomi";

                        newDepts.push(d);
                    });

                    rector.departments = newDepts;
                }

                // Filter out hidden 
                data = data.filter(r => !r.hidden);

                // Handle "Yoshlar masalalari" pro-rector
                const yoshlarProRectorIndex = data.findIndex(r => r.position_uz && normalize(r.position_uz).includes('yoshlar') && normalize(r.position_uz).includes('prorektor'));
                if (yoshlarProRectorIndex !== -1) {
                    const yoshlarRector = data[yoshlarProRectorIndex];
                    let currentDepts = yoshlarRector.departments || [];
                    
                    currentDepts.forEach(d => {
                        const dbName = normalize(d.name_uz);
                        if (dbName.includes("yoshlar bilan ishlash")) d.short_id = "yoshlar-bilan-ishlash";
                        else if (dbName.includes("axborot-resurs")) d.short_id = "axborot-resurs-markazi";
                        else if (dbName.includes("tyutor")) d.short_id = "tyutorlar-faoliyati";
                        else if (dbName.includes("psixolog")) d.short_id = "psixolog";
                        else if (dbName.includes("yoshlar uyushmasi")) d.short_id = "yoshlar-uyushmasi-klublar";
                        else if (dbName.includes("sport klubi")) d.short_id = "sport-klubi";
                    });
                    yoshlarRector.departments = currentDepts;
                }

                // Handle "Ilmiy ishlar" pro-rector
                const ilmiyProRectorIndex = data.findIndex(r => r.position_uz && normalize(r.position_uz).includes('ilmiy') && normalize(r.position_uz).includes('prorektor'));
                if (ilmiyProRectorIndex !== -1) {
                    const ilmiyRector = data[ilmiyProRectorIndex];
                    let currentDepts = ilmiyRector.departments || [];
                    
                    currentDepts.forEach(d => {
                        const dbName = normalize(d.name_uz);
                        if (dbName.includes("ilmiy tadqiqotlar")) {
                             d.id = 11;
                             d.short_id = 'ilmiy-tadqiqotlar';
                        }
                    });
                    ilmiyRector.departments = currentDepts;
                }

                const updatedData = data.filter(rector => rector.employee?.id !== 275).map(rector => {
                    const pos = rector.position_uz || "";

                    const posLower = pos.toLowerCase();

                    // Set name and disable link for Xalqaro transformatsiya
                    if (posLower.includes("xalqaro transformatsiya") || posLower.includes("xalqaro hamkorlik")) {
                        return {
                            ...rector,
                            position_uz: "Xalqaro transformatsiya va strategik rivojlantirish bo'yicha prorektor",
                            disableLink: true
                        };
                    }

                    // Remove the department from the "Ta'lim sifati" card (fixing duplication)
                    if (pos.includes("Ta'lim sifati nazorati")) {
                        return {
                            ...rector,
                            departments: (rector.departments || []).filter(d =>
                                !normalize(d.name_uz).includes("ilmiy tadqiqotlar")
                            )
                        };
                    }

                    return rector;
                });

                // Custom sorting to push Xalqaro prorector to the very end
                updatedData.sort((a, b) => {
                    const posA = a.position_uz ? a.position_uz.toLowerCase() : "";
                    const posB = b.position_uz ? b.position_uz.toLowerCase() : "";
                    
                    const isXalqaroA = posA.includes("xalqaro transformatsiya") || posA.includes("xalqaro hamkorlik");
                    const isXalqaroB = posB.includes("xalqaro transformatsiya") || posB.includes("xalqaro hamkorlik");
                    
                    if (isXalqaroA && !isXalqaroB) return 1;
                    if (!isXalqaroA && isXalqaroB) return -1;
                    return 0;
                });

                setRectors(updatedData);
            })
            .catch((error) => console.error("Error fetching rectors data: ", error));
    }, [i18n.language]);

    const nameToKey = {
        "Xalqaro hamkorlik bo‘yicha prorektor": "prorektor_xalqaro",
        "Xalqaro hamkorlik va reytinglar bilan ishlash boshqarmasi": "boshqarma_xalqaro",
        "Xorijiy ta’lim hamkorligi markazlari rahbari-prorektor": "prorektor_xorijiy",
        "Rektor apparati – rektor yordamchisi va maslahatchilari": "rektor_apparati",
        "Inson resurslarini boshqarish boshqarmasi": "boshqarma_inson_resurslari",
        "Universitet axborot xizmati": "axborot_xizmati_uni",
        "Yuriskonsult, “Komplayens nazorat”": "yuriskonsult_komplayens",
        "Kengashlar va majlislar kotibi": "kotib_kengashlar",
        "Ijro intizomi, arxiv va murojaatlar bilan ishlash bo‘limi": "bolim_ijro_intizomi",
        "Yoshlar bilan ishlash, ma’naviyat va ma’rifat boshqarmasi": "boshqarma_yoshlar",
        "Axborot-resurs markazi": "axborot_resurs_markazi_uni",
        "Tyutorlar faoliyatini muvoxiqlashtirish bo‘limi": "bolim_tyutorlar",
        "Psixolog": "psixolog",
        "Yoshlar uyushmasi, klublar va to‘garaklar": "klublar_togaraklar",
        "Sport klubi kotibi": "sport_klubi_kotibi",
        "Ilmiy tadqiqotlar, innovatsiyalar, ilmiy-pedagog kadrlarni tayyorlash va iqtidorli talabalar bilan ishlash boshqarmasi": "boshqarma_ilmiy",
        "Buxgalteriya": "buxgalteriya",
        "Ishlar boshqarmasi": "ishlar_boshqarmasi",
        "Bosh muhandis-texnolog": "muhandis_texnolog",
        "Texnik foydalanish va xo‘jalik bo‘limi": "bolim_xo'jalik"
    };

    const getTranslatedName = (item, nameField, posField) => {
        const uzName = item[nameField] || item[posField];
        if (uzName && nameToKey[uzName]) {
            return t(nameToKey[uzName]);
        }

        if (i18n.language === 'uz') return uzName;
        const langBody = (nameField && item[`${nameField.split('_')[0]}_${i18n.language}`]) ||
            (posField && item[`${posField.split('_')[0]}_${i18n.language}`]);

        return langBody || uzName;
    };

    const getIcon = (name) => {
        const n = name.toLowerCase();
        if (n.includes("xodim")) return <FaUsersCog />;
        if (n.includes("arxiv") || n.includes("monitoring") || n.includes("ijro")) return <FaFileAlt />;
        if (n.includes("yurist") || n.includes("kurashish") || n.includes("komplayens")) return <FaBalanceScale />;
        if (n.includes("auditor")) return <FaSearch />;
        if (n.includes("matbuot") || n.includes("axborot")) return <FaBullhorn />;
        if (n.includes("kengash")) return <FaBriefcase />;
        if (n.includes("xalqaro")) return <FaGlobe />;
        if (n.includes("yoshlar") || n.includes("ma'naviyat")) return <FaBook />;
        if (n.includes("psixolog")) return <FaBrain />;
        if (n.includes("hamshira")) return <FaStethoscope />;
        if (n.includes("o'quv") || n.includes("boshqarma")) return <FaGraduationCap />;
        if (n.includes("marketing")) return <FaChartLine />;
        if (n.includes("laboratoriya")) return <FaFlask />;
        if (n.includes("innovatsiya") || n.includes("tadqiqot")) return <FaMicroscope />;
        if (n.includes("sifat")) return <FaAward />;
        if (n.includes("it") || n.includes("raqamli") || n.includes("resurs")) return <FaLaptopCode />;
        if (n.includes("buxgalteriya") || n.includes("moliya")) return <FaCalculator />;
        if (n.includes("xo'jalik")) return <FaHistory />;
        if (n.includes("muhandis")) return <FaCogs />;
        return <FaUniversity />;
    };

    return (
        <div className={styles.mainContainer}>
            <h1 className={styles.pageTitle}>{t("universityStructure") || "Universitet Tuzilmasi"}</h1>

            <div className={styles.structureList}>
                {rectors.map((rector, index) => {
                    // Check if this is the main Rector (not Pro-Rector)
                    const isMainRector = (rector.position_uz || "").toLowerCase().includes('rektor') && !(rector.position_uz || "").toLowerCase().includes('prorektor');

                    return (
                        <div key={rector.id || index} className={styles.sectionContainer}>
                            {isMainRector ? (
                                // Float Layout for Main Rector
                                <div className={styles.wrapper}>
                                    {/* Left Side Side-Box */}
                                    {rector.disableLink ? (
                                        <div className={`${styles.sideBox} ${styles.floatSideBox}`} style={{ cursor: "default" }}>
                                            <div className={styles.sideIcon}><FaUniversity /></div>
                                            <h3 className={styles.sideTitle}>
                                                {getTranslatedName(rector, null, 'position_uz')}
                                            </h3>
                                        </div>
                                    ) : (
                                        <Link to={`/employee/${rector.employee?.id || 274}`} className={`${styles.sideBox} ${styles.floatSideBox}`}>
                                            <div className={styles.sideIcon}><FaUniversity /></div>
                                            <h3 className={styles.sideTitle}>
                                                {getTranslatedName(rector, null, 'position_uz')}
                                            </h3>
                                        </Link>
                                    )}

                                    {/* Departments - Direct Children for Float Layout */}
                                    {rector.departments && rector.departments.map((dept, idx) => {
                                        let link = dept.short_id ? `/centers/${dept.short_id}` : `/centers/${dept.id}`;
                                        if (dept.type === 'employee') link = `/employee/${dept.id}`;
                                        else if (dept.is_new) link = "#";

                                        return (
                                            <Link
                                                key={dept.id || idx}
                                                to={link}
                                                className={`${styles.itemCard} ${styles.floatItem} ${dept.name_uz.toLowerCase().includes('prorektor') ? styles.proRectorCard : ''}`}
                                                onClick={(e) => { if (link === '#') e.preventDefault(); }}
                                            >
                                                <div className={styles.itemIcon}>{getIcon(dept.name_uz)}</div>
                                                <div className={styles.itemText}>
                                                    <h4>
                                                        {getTranslatedName(dept, 'name_uz', null)}
                                                    </h4>
                                                </div>
                                            </Link>
                                        );
                                    })}
                                </div>
                            ) : (
                                // Flex Layout for Pro-Rectors
                                <div className={styles.flexLayout}>
                                    {/* Left Side Side-Box */}
                                    {rector.disableLink ? (
                                        <div className={styles.sideBox} style={{ cursor: "default" }}>
                                            <div className={styles.sideIcon}><FaUniversity /></div>
                                            <h3 className={styles.sideTitle}>
                                                {getTranslatedName(rector, null, 'position_uz')}
                                            </h3>
                                        </div>
                                    ) : (
                                        <Link to={`/employee/${rector.employee?.id || 274}`} className={styles.sideBox}>
                                            <div className={styles.sideIcon}><FaUniversity /></div>
                                            <h3 className={styles.sideTitle}>
                                                {getTranslatedName(rector, null, 'position_uz')}
                                            </h3>
                                        </Link>
                                    )}

                                    {/* Right Side Info & Grid */}
                                    <div className={styles.contentArea}>
                                        <div className={styles.itemsGrid}>
                                            {rector.departments && rector.departments.map((dept, idx) => {
                                                let link = dept.short_id ? `/centers/${dept.short_id}` : `/centers/${dept.id}`;
                                                if (dept.type === 'employee') link = `/employee/${dept.id}`;
                                                else if (dept.is_new) link = "#";

                                                return (
                                                    <Link
                                                        key={dept.id || idx}
                                                        to={link}
                                                        className={`${styles.itemCard} ${dept.name_uz.toLowerCase().includes('prorektor') ? styles.proRectorCard : ''}`}
                                                        onClick={(e) => { if (link === '#') e.preventDefault(); }}
                                                    >
                                                        <div className={styles.itemIcon}>{getIcon(dept.name_uz)}</div>
                                                        <div className={styles.itemText}>
                                                            <h4>
                                                                {getTranslatedName(dept, 'name_uz', null)}
                                                            </h4>
                                                        </div>
                                                    </Link>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Department;
